/**
 * @file LocalStorage 鍵值常數
 * @description 定義 LocalStorage 使用的所有鍵值名稱
 */
export const LocalStorageKeys = {
  UserInfo: '_gdSecretKey',
  SetSideMenu: 'setSideMenu'
} as const;

export type LocalStorageKey = keyof typeof LocalStorageKeys;
export type LocalStorageKeyValue = (typeof LocalStorageKeys)[LocalStorageKey];

export default LocalStorageKeys;
